import React, { useRef } from 'react';
import { Button, FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';

const Custom = ({ isLoading, site_map, robots, onRemoveFile, onChangeFileInput }) => {
  const inputSitemapRef = useRef(null);
  const inputRobotsRef = useRef(null);

  return (
    <>
      {site_map ? (
        <FormGroup>
          <Row>
            <Col md={12}>
              <FormGroup>
                <ControlLabel>{site_map?.title}</ControlLabel>
                <div className="form-group__custom">
                  <Button bsSize="xsmall" disabled={isLoading.site_map} onClick={() => inputSitemapRef?.current?.click()}>
                    {isLoading.site_map ? <Spinner /> : null}
                    <span>{site_map?.action_button}</span>
                  </Button>
                  <div className="form-group__custom-text">{site_map?.current}</div>
                  {!isLoading.site_map && site_map?.current !== 'No file chosen' ? (
                    <span className="fas fa-times remove" onClick={() => onRemoveFile('site_map')} />
                  ) : null}
                  <FormControl
                    type="file"
                    className="d-none"
                    accept=".xml"
                    inputRef={(ref) => (inputSitemapRef.current = ref)}
                    onChange={(e) => onChangeFileInput('site_map', e)}
                  />
                </div>
              </FormGroup>
              <span className="help-block" dangerouslySetInnerHTML={{ __html: site_map?.info }} />
            </Col>
          </Row>
        </FormGroup>
      ) : null}
      {robots ? (
        <FormGroup>
          <Row>
            <Col md={12}>
              <FormGroup>
                <ControlLabel>{robots?.title}</ControlLabel>
                <div className="form-group__custom">
                  <Button bsSize="xsmall" disabled={isLoading.robots} onClick={() => inputRobotsRef?.current?.click()}>
                    {isLoading.robots ? <Spinner /> : null}
                    <span>{robots?.action_button}</span>
                  </Button>
                  <div className="form-group__custom-text">{robots?.current}</div>
                  {!isLoading.robots && robots?.current !== 'No file chosen' ? (
                    <span className="fas fa-times remove" onClick={() => onRemoveFile('robots')} />
                  ) : null}
                  <FormControl
                    type="file"
                    className="d-none"
                    accept=".txt"
                    inputRef={(ref) => (inputRobotsRef.current = ref)}
                    onChange={(e) => onChangeFileInput('robots', e)}
                  />
                </div>
              </FormGroup>
              <span className="help-block" dangerouslySetInnerHTML={{ __html: robots?.info }} />
            </Col>
          </Row>
        </FormGroup>
      ) : null}
    </>
  );
};

Custom.propTypes = {
  isLoading: PropTypes.object,
  site_map: PropTypes.object,
  robots: PropTypes.object,
  onRemoveFile: PropTypes.func,
  onChangeFileInput: PropTypes.func,
};

export default Custom;
